import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReceiptModeModel } from '@shared/data-access/models';
import { filter, Observable, take } from 'rxjs';
import { ReceiptModeAction } from '../actions';
import { ReceiptModeReducer } from '../reducers';
import { ReceiptModeSelector } from '../selectors';

@Injectable()
export class ReceiptModeFacade {
  selectedItem$ = this._store.select(ReceiptModeSelector.selectReceiptMode);

  constructor(private _store: Store<ReceiptModeReducer.ReceiptModeState>) {}

  getById(id: number): Observable<ReceiptModeModel | null> {
    this._store.dispatch(ReceiptModeAction.loadItem({ id }));
    return this.selectedItem$.pipe(
      filter(val => !!val && val.id === id),
      take(1)
    ) as Observable<ReceiptModeModel | null>;
  }
}
